import Autosuggest from 'react-autosuggest';
import React from 'react'

const match = require('autosuggest-highlight/match');
const parse = require('autosuggest-highlight/parse');
// Imagine you have a list of languages that you'd like to autosuggest.
export default class SearchSuggestion extends React.Component {
  constructor(props) {
    super(props);
    //console.log(this.props)
    this.state = {
      value: '',
      suggestions: [],
      item:[]
    };
  }
  getSuggestions(value){
    const inputValue = value.trim().toLowerCase(); 
    return this.state.item.filter(val =>
     val.toLowerCase().includes(inputValue) 
    );
   // return val.toLowerCase.indludes(this.state.item.Name)
  }
  getSuggestionValue(suggestion){
    return suggestion
  }
  shouldRenderSuggestions(value) {
    //console.log('hit')
    return true
  }
  renderSuggestion(suggestion, { query }) {
    const matches = match(suggestion, query);
    const parts = parse(suggestion, matches);
      return (
        <span>
          {parts.map((part, index) => {
            const Style = part.highlight ? {fontWeight:'bold'} : null;
            return (
              <span style={Style} key={index}>
                {part.text}
              </span>
            );
          })}
        </span>
      );
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    // console.log(event)
    this.props.self.query = suggestionValue
    this.props.self.setState({
      // query: suggestionValue,
      dontRender : false
    })
    if(method === 'click'){
      this.props.self.searchKeyHandler(event,1)
    }
    // console.log(this)
  }

 /* onSuggestionHighlighted = ({ suggestion }) => {
    this.props.self.setState({
      query: suggestion,
      // dontRender : false
    })
  }*/

  onChange = (event, { newValue, method }) => {
    //console.log(method)
    this.props.self.query = newValue;
    this.setState({
      value: newValue
    });
    this.props.self.setState({
      query: newValue,
     // dontRender : false
    })
    event.preventDefault()
  };

  onBlur = () => {
    this.props.self.setState({
      dontRender : true
    })
  };

  onClick = () => {

    this.props.self.setState({
      dontRender : true
    })
  }

  onKeyPress = (event) => {
    // if (event.key !== 'Enter'){
    //   this.props.self.setState({
    //     dontRender : true
    //   })
    // }else{

      this.props.self.searchKeyHandler(event)
    // }
  }

  onSuggestionsFetchRequested = ({ value,reason }) => {
    //console.log(reason)
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  

  shouldComponentUpdate(nextProps, nextState){
    nextState.item = this.props.self.getFilterAutoSuggestionItems(this.props.self.state.filterField,nextProps.self.state.siteData)
    return true;
  }

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: 'Type to search',
      value,
      onChange: this.onChange,
      onBlur : this.onBlur,
      onClick : this.onClick,
      onKeyPress: ((event)=> this.onKeyPress(event)),

    };

    return (
      <Autosuggest
        suggestions={suggestions}
        // alwaysRenderSuggestions={true}
        onSuggestionHighlighted={this.onSuggestionHighlighted}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        shouldRenderSuggestions={this.shouldRenderSuggestions}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        theme={theme}
      />
    );
  }
}
const theme = {
  container: {
    position: 'absolute',
    width: '100%',
    alignSelf: 'center',
  },
  input: {
    boxSizing: 'border-box',
    border: '1px solid transparent',
    width: '100%',
    height: '100%',
    padding: '0px 12px',
    // borderRadius: '0px 3px 3px 0px',
    // boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 1px',
    fontSize: 14,
    outline: 'none',
  },
  inputFocused: {
    outline: 'none'
  },
  inputOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  suggestionsContainer: {
    display: 'none'
  },
  suggestionsContainerOpen: {
    display: 'block',
    position: 'absolute',
    // top: 0,
    width: '100%',
    border: '1px solid #aaa',
    backgroundColor: '#fff',
    fontFamily: 'Helvetica, sans-serif',
    //fontWeight: 300,
    fontSize: 14,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 2
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  suggestion: {
    cursor: 'pointer',
    padding: '5px 10px'
  },
  suggestionHighlighted: {
    backgroundColor: '#ddd'
  },
};



// WEBPACK FOOTER //
// ./src/App/topmenu/job/helper/component/RenderAutoSuggest.js